module.exports = "data:image/png;base64,"


//////////////////
// WEBPACK FOOTER
// ./src/assets/aqua_harps4_com/images/logo03.png
// module id = 310
// module chunks = 0